var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sortable-list',{staticClass:"page-list",attrs:{"link":"/dashboard/setting/users/approve/","default-sort":"firstname","title":_vm.$t('list-user.approve-title'),"items":_vm.internalList,"parameters":_vm.unveriFiedlistParameters,"has-pagination":_vm.pagination},on:{"item-click":_vm.unverifiedItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }